export default "__VITE_ASSET__Vkr4_tLe__"